import $ from 'jquery'
import 'core-js/stable'
import 'regenerator-runtime/runtime'

import './component.scss'

// ルートクラス定義
const ROOT_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-root-target'
const ROOT_TARGET_SELECTOR = `.${ROOT_TARGET_CLASS_NAME}`

const switchTab = () => {
  // セレクタ定義
  const ACTIVE_TRIGGER_CLASS_NAME = 'js-mainvisualSearchWidget-switchTab-active-trigger'
  const ACTIVE_TRIGGER_SELECTOR = `.${ACTIVE_TRIGGER_CLASS_NAME}`

  const ACTIVE_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-switchTab-active-target'
  const ACTIVE_TARGET_SELECTOR = `.${ACTIVE_TARGET_CLASS_NAME}`

  // アクティブ状態のクラス定義
  const ACTIVE_CLASS_NAME = 'is-active'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $switchTabActiveTrigger = $(root).find(ACTIVE_TRIGGER_SELECTOR)
    const $switchTabActiveTarget = $(root).find(ACTIVE_TARGET_SELECTOR)

    $switchTabActiveTrigger.on('click', (event) => {
      event.preventDefault() // イベントの無効化

      const $currentTrigger = $(event.currentTarget)
      const $showTargetElement = $switchTabActiveTarget.filter($($currentTrigger.attr('href')))

      // トリガーのアクティブ状態の変更
      $switchTabActiveTrigger.removeClass(ACTIVE_CLASS_NAME)
      $currentTrigger.addClass(ACTIVE_CLASS_NAME)

      // 切り替え対象のアクティブ状態変更
      $switchTabActiveTarget.removeClass(ACTIVE_CLASS_NAME)
      $showTargetElement.addClass(ACTIVE_CLASS_NAME)
    })
  })
}

const areaSelect = () => {
  // セレクタ定義
  const REGION_GROUP_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-areaSelect-regionGroup-target'
  const REGION_GROUP_TARGET_SELECTOR = `.${REGION_GROUP_TARGET_CLASS_NAME}`

  const REGION_BUTTON_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-areaSelect-regionButton-target'
  const REGION_BUTTON_TARGET_SELECTOR = `.${REGION_BUTTON_TARGET_CLASS_NAME}`

  const PREFECTURE_GROUP_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-areaSelect-prefectureGroup-target'
  const PREFECTURE_GROUP_TARGET_SELECTOR = `.${PREFECTURE_GROUP_TARGET_CLASS_NAME}`

  const BACK_TO_REGION_CONTAINER_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-areaSelect-backToRegionContainer-target'
  const BACK_TO_REGION_CONTAINER_TARGET_SELECTOR = `.${BACK_TO_REGION_CONTAINER_TARGET_CLASS_NAME}`

  const BACK_TO_REGION_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-areaSelect-backToRegion-target'
  const BACK_TO_REGION_TARGET_SELECTOR = `.${BACK_TO_REGION_TARGET_CLASS_NAME}`

  // 表示状態のクラス定義
  const SHOW_CLASS_NAME = 'is-show'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $regionGroupTarget = $(root).find(REGION_GROUP_TARGET_SELECTOR)
    const $regionButtonTarget = $(root).find(REGION_BUTTON_TARGET_SELECTOR)
    const $prefectureGroupTarget = $(root).find(PREFECTURE_GROUP_TARGET_SELECTOR)
    const $backToRegionContainerTarget = $(root).find(BACK_TO_REGION_CONTAINER_TARGET_SELECTOR)
    const $backToRegionTarget = $(root).find(BACK_TO_REGION_TARGET_SELECTOR)

    $regionButtonTarget.on('click', (event) => {
      const $currentButton = $(event.currentTarget)
      const regionId = $currentButton.data('region-id')

      // 地域選択を非表示に
      $regionGroupTarget.hide()

      // 対応する都道府県を表示する
      $prefectureGroupTarget.filter((index, prefectureGroup) => $(prefectureGroup).data('region-id') == regionId).addClass(SHOW_CLASS_NAME)

      // 地域選択に戻るボタンを表示
      $backToRegionContainerTarget.show()
    })

    $backToRegionTarget.on('click', () => {
      // 都道府県を非表示に
      $prefectureGroupTarget.removeClass(SHOW_CLASS_NAME)

      // 地域選択を表示
      $regionGroupTarget.show()

      // 地域選択に戻るボタンを非表示
      $backToRegionContainerTarget.hide()
    })
  })
}

const constructionPartsSelect = () => {
  // セレクタ定義
  const REGION_GROUP_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-constructionPartsSelect-regionGroup-target'
  const REGION_GROUP_TARGET_SELECTOR = `.${REGION_GROUP_TARGET_CLASS_NAME}`

  const REGION_BUTTON_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-constructionPartsSelect-regionButton-target'
  const REGION_BUTTON_TARGET_SELECTOR = `.${REGION_BUTTON_TARGET_CLASS_NAME}`

  const PREFECTURE_GROUP_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-constructionPartsSelect-prefectureGroup-target'
  const PREFECTURE_GROUP_TARGET_SELECTOR = `.${PREFECTURE_GROUP_TARGET_CLASS_NAME}`

  const BACK_TO_REGION_CONTAINER_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-constructionPartsSelect-backToRegionContainer-target'
  const BACK_TO_REGION_CONTAINER_TARGET_SELECTOR = `.${BACK_TO_REGION_CONTAINER_TARGET_CLASS_NAME}`

  const BACK_TO_REGION_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-constructionPartsSelect-backToRegion-target'
  const BACK_TO_REGION_TARGET_SELECTOR = `.${BACK_TO_REGION_TARGET_CLASS_NAME}`

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $regionGroupTarget = $(root).find(REGION_GROUP_TARGET_SELECTOR)
  })
}

const activateSubmit = () => {
  // セレクタ定義
  const CONSTRUCTION_PARTS_INPUT_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-activateSubmit-constructionPartsInput-target'
  const CONSTRUCTION_PARTS_INPUT_TARGET_SELECTOR = `.${CONSTRUCTION_PARTS_INPUT_TARGET_CLASS_NAME}`

  const BUTTON_TARGET_CLASS_NAME = 'js-mainvisualSearchWidget-activateSubmit-button-target'
  const BUTTON_TARGET_SELECTOR = `.${BUTTON_TARGET_CLASS_NAME}`

  // アクティブ状態のクラス定義
  const ACTIVE_CLASS_NAME = 'is-active'

  // 処理
  const $rootElement = $(ROOT_TARGET_SELECTOR)

  $rootElement.each((index, root) => {
    const $submitButton = $(root).find(BUTTON_TARGET_SELECTOR)
    const $constructionPartsInput = $(root).find(CONSTRUCTION_PARTS_INPUT_TARGET_SELECTOR)

    // ボタン活性化判定処理
    const determinationOfActivation = () => {
      const constructionPartsValueArray = $.map($(root).find(`${CONSTRUCTION_PARTS_INPUT_TARGET_SELECTOR}:checked`), (constructionPartsInput) => {
        return $(constructionPartsInput).val()
      }).filter((value) => value)

      if (constructionPartsValueArray.length > 0) {
        $submitButton.addClass(ACTIVE_CLASS_NAME)
      } else {
        $submitButton.removeClass(ACTIVE_CLASS_NAME)
      }
    }

    $constructionPartsInput.on('change', determinationOfActivation)
  })
}

$(() => {
  // タブ切り替え処理
  switchTab()

  // エリア選択処理
  areaSelect()

  // 工事箇所選択処理
  constructionPartsSelect()

  // 工事箇所選択の検索ボタン活性化処理
  activateSubmit()
})
